__turbopack_context__.v({
  "logo": "TimelineElement-module__2Pfo7a__logo",
});
